import React, { useState, useEffect, useMemo } from "react";
import { tokens } from "../../public/tokens.js";
import { getResultStyle, getMarkColor, formatResult, pdfGetResultStyle, pdfGetMarkStyle, buildGradebookHtml } from "./GradebookHelperUtils";
import { GetSubjectAssignments, generateSubjectSORpdf, getBrandSignature } from "../../services/QualificationService.js";
import SkeletonStudentHub from "../../loaders/SkeletonStudentHub.js";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Swal from "sweetalert2";


const styles = {

    gradeBook: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "24px",
        alignSelf: "stretch",
        width: "100%",
    },
    overallResultsBox: {
        display: "flex",
        width: "100%",
        padding: "12px 0 12px 24px",
        borderRadius: tokens.globals["border-radius"],
        border: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
        boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.05)",
    },
    infoColumn: {
        display: "flex",
        padding: "3px 28px 3px 0",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "10px",
        flex: "1 0 0",
    },
    markResultColumn: {
        display: "flex",
    },
    courseResult: {
        fontSize: tokens.typography.fontSize["base-16px"],
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "16.8px",
    },
    tableResultBox: {
        display: "flex",
        alignItems: "center",
        alignSelf: "stretch",
        flexDirection: "column",
        background: tokens.colors.ui.background,
        borderRadius: tokens.globals["border-radius"],
        border: `1px solid ${tokens.colors.ui.border}`,
        overflow: "hidden",
    },
    tableHeader: {
        display: "flex",
        width: "100%",
        height: "56px",
        borderBottom: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
        color: tokens.colors.neutral.grey["800"],
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.bold,
    },
    tableContent: {
        display: "flex",
        width: "100%",
        minHeight: "56px",
        alignItems: "stretch",
        borderBottom: `1px solid ${tokens.colors.ui.border}`,
        background: tokens.colors.ui.background,
    },
    assessmentCell: {
        display: "flex",
        minHeight: "50px",
        minWidth: "0px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        flex: "1 0 0",
        padding: "12px 0 12px 24px",
        borderRight: `1px solid ${tokens.colors.ui.border}`,
    },
    markResultCell: {
        display: "flex",
        padding: "0 12px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "20%",
        gap: "12px",
        borderRight: `1px solid ${tokens.colors.ui.border}`,
    },
    assessmentName: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        color: tokens.colors.brand.blue["500"],
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.bold,
        lineHeight: "130%",
    },
    assessmentMark: {
        display: "flex",
        width: "59px",
        height: "30px",
        flexDirection: "column",
        justifyContent: "center",
        color: tokens.colors.neutral.grey["800"],
        textAlign: "center",
        fontSize: tokens.typography.fontSize["lg-14px"],
        fontWeight: tokens.typography.fontWeights.regular,
        lineHeight: "110%",
        letterSpacing: "0.07px",
    },
    metaData: {
        color: tokens.colors.text.secondary,
        fontSize: tokens.typography.fontSize["md-12px"],
        fontWeight: tokens.typography.fontWeights.regular,
    },
    failRow: {
        background: "rgba(196, 62, 81, 0.05)",
    },
    witheldText: {
        color: tokens.colors.brand["burnt-orange"]["600"],
        fontWeight: tokens.typography.fontWeights.semibold,
        textTransform: "uppercase",
    },
    noRecords: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    assesmentType: {
        fontSize: tokens.typography.fontSize["md-12px"],
        fontWeight: tokens.typography.fontWeights.semibold,
        color: tokens.colors.neutral.grey["600"],
    },
    assesmentHeader:
    {
        display: "flex",
        alignItems: "baseline",
        gap: "10px",
        fontSize: tokens.typography.fontSize["lg-14px"],
    },
    anglesIcon: {
            fontSize: tokens.typography.fontSize["sm-10px"],
            paddingLeft: "8px",
        },
}

export const SoRButton = styled.button`
    display: flex;
    height: 35px;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    font-size: ${tokens.typography.fontSize["lg-14px"]};
    font-weight: ${tokens.typography.fontWeights.semibold};
    color: ${tokens.colors.neutral.white};
    border: none;
    border-radius: ${tokens.globals["border-radius"]};
    background: ${tokens.colors.theme["button-color"]};
    box-shadow: ${tokens.effects.shadow};
`;

const RobotResult = (gradeText) => (
    gradeText === "Incomplete" ? (
        <div className="as-red">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Incomplete
            </p>
        </div>
    ) : gradeText === "Competent" ? (
        <div className="as-green">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Competent
            </p>
        </div>
    ) : (
        <div className="as-orange">
            <p className="gradeRobot">
                <i className="gradeRobotIcon fas fa-circle"></i> Not Yet Competent
            </p>
        </div>
    )
);

const SubjectGradebook = ({ sid, passStatus, gradeText, intakeLockStatus, subjectName, subjectIntake, subjectDuration }) => {

    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);

    useEffect(() => {
        const load = async () => {
            if (!sid) return;

            setLoading(true);
            setLoadingRows(true);
            try {
                const res = await GetSubjectAssignments({ sid });
                setAssignments(res?.data || []);
            } catch (err) {
                setAssignments([]);
            } finally {
                setLoading(false);
                setLoadingRows(false);
            }
        };
        load();
    }, [sid]);

    const rows = useMemo(() => {

        const assignmentsArray = Array.isArray(assignments) ? assignments : [];

        return (assignmentsArray)
            .filter((item) => item.grant_exemption === 0)
            .map((item) => {

                const student = item.studentCourses?.find(
                    (sc) => sc.intake == sid
                );

                return {
                    name: item.name,
                    type: item.ass_type,
                    isWithheld:
                        student?.gradeText?.toLowerCase() === "witheld",
                    gradingType: student?.grading_type,
                    mark:
                        student?.gradeText?.toLowerCase() === "witheld"
                            ? "WITHHELD"
                            : (item?.notify_assessed === 0
                                ? "-"
                                : student?.gradeText ?? "-"),
                    result:
                        student?.gradeText?.toLowerCase() === "witheld"
                            ? "Withheld"
                            : item?.status === "Closed Not-Submitted"
                                ? "Not Submitted"
                                : (item?.notify_assessed === 0
                                    ? "Pending"
                                    : (student?.pass_status
                                        ? formatResult(student.pass_status)
                                        : "Pending")),

                    code: item.code ?? "",
                };
            });
    }, [assignments, sid]);


    const summary = {
        overallGrade: gradeText ?? "-",
        overallResult: passStatus ?? "Pending",
    };

    const user = useSelector((state) => state.user);
    const studentName = user.fullname;
    const studentNum = user.student_crm_id
    const idPassport = user.number

    const downloadPdfSOR = async () => {
        setLoadingPdf(true);
        try {
            
            const htmlContent = buildGradebookHtml({
                rows,
                summary,
                intakeLockStatus,
                studentName,
                studentNum,
                idPassport,
                subjectName,
                subjectIntake,
                subjectDuration,
            });

            Swal.fire({
                icon: "info",
                title: "File Downloading...",
                showConfirmButton: "ok",
                onOpen: () => Swal.showLoading(),
            });

            const res = await generateSubjectSORpdf({
                htmlContent,
                fileName: "InterimSOR.pdf",
                size: "1",
            });

            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `${subjectName}-Interim-SoR.pdf`;
            anchor.click();

            window.URL.revokeObjectURL(url);

            Swal.close();

            Swal.fire({
                icon: "success",
                title: "Download complete",
                timer: 1500,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });

        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Error while downloading file",
                confirmButtonText: "OK",
            });
        } finally {
            setLoadingPdf(false);
        }
    };

    if (loading) {
        return <SkeletonStudentHub />;
    }

    if (!rows || rows.length === 0) {
        return (
            <div style={styles.noRecords}>There are no records to show.</div>
        );
    }

    return (
        <>
            <div style={styles.gradeBook}>
                {intakeLockStatus === 1 && (<div className="courseGradesFinalResultBox" style={styles.overallResultsBox} >
                    <div style={styles.infoColumn} >
                        <div style={styles.courseResult} >Course Results</div>
                        <div>Overall course performance summary</div>
                    </div>
                    <div className="courseGradesFinalResultBoxItem" style={styles.markResultColumn} >
                        <div>Grade</div>
                        <div style={getMarkColor(formatResult(summary.overallResult) ?? "-")}>{summary.overallGrade ?? "-"}</div>
                    </div>
                    <div className="courseGradesFinalResultBoxItem" style={styles.markResultColumn} >
                        <div>Outcome</div>
                        <div style={getResultStyle(formatResult(summary.overallResult) ?? "Pending")}>{formatResult(summary.overallResult) ?? "Pending"}</div>
                    </div>
                </div>)}
                <div style={styles.tableResultBox}>
                    <div style={styles.tableHeader}>
                        <div style={styles.assessmentCell}>
                            <span style={styles.assessmentHeader}>Assessments <i style={styles.anglesIcon} className="fal fa-angles-up-down" /></span>
                            <div></div>
                        </div>
                        <div style={styles.markResultCell}>
                            <span>Grade</span>
                        </div>
                        <div style={{
                            ...styles.markResultCell,
                            borderRight: "none",
                        }}>
                            <span>Result</span>
                        </div>
                    </div>
                    {loadingRows ? (
                        <SkeletonStudentHub />
                    ) : (
                        rows?.length > 0 &&
                        rows.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    ...styles.tableContent,
                                    ...(index === rows.length - 1 && { borderBottom: "none" }),
                                    ...((item.result === "Fail" || item.result === "Not Submitted") ? styles.failRow : {}),
                                }}
                            >
                                <div style={styles.assessmentCell}>
                                    <span className="gradesTableAssesmentName" style={styles.assessmentName}>{item.name}</span>
                                    <span>
                                        <span style={styles.assesmentType}>{item.type}</span>
                                        <span style={styles.metaData}> {item.code}</span>
                                    </span>
                                </div>
                                <div style={styles.markResultCell}>
                                    {item.gradingType == "1" ? (
                                        RobotResult(item.mark)
                                    ) : (
                                        <span
                                            style={item.isWithheld ? styles.witheldText : styles.assessmentMark}
                                        >
                                            {item.mark}
                                        </span>
                                    )}
                                </div>
                                <div style={{
                                    ...styles.markResultCell,
                                    borderRight: "none",
                                }}>
                                    <span style={getResultStyle(item.result ?? "Pending")}>
                                        {item.result ?? "Pending"}
                                    </span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div>
                    <SoRButton onClick={downloadPdfSOR} style={styles.dlSORButton} disabled={loadingPdf} >
                        {loadingPdf
                            ? "Generating PDF..."
                            : "Interim Statement of Results"}
                        <i className={loadingPdf ? "fas fa-spinner fa-spin" : "fal fa-download"} style={{ marginLeft: "8px" }} ></i>
                    </SoRButton>
                </div>
            </div>
        </>
    );
};

export default SubjectGradebook;